import { isDesktopApp } from "~/utils/misc";

export function scaledDimension(picture, offsetRight = 0) {
  const maxHeight = window.innerHeight - (isDesktopApp() ? 0 : 48) - 32;
  const maxWidth = window.innerWidth - 32 - offsetRight;
  const maxScaledHeight = (maxWidth * picture.height) / picture.width;
  const maxScaledWidth = (maxHeight * picture.width) / picture.height;
  let scaledHeight = (maxHeight == maxScaledHeight) ? maxScaledHeight : null;
  if (maxWidth >= maxScaledWidth) {
    scaledHeight = maxHeight
  }
  let scaledWidth = (maxWidth == maxScaledWidth) ? maxScaledWidth : null;
  if (maxHeight >= maxScaledHeight) {
    scaledWidth = maxWidth
  }
  if (is.not.existy(scaledHeight)) {
    scaledHeight = (scaledWidth * picture.height) / picture.width;
  } else if (is.not.existy(scaledWidth)) {
    scaledWidth = (scaledHeight * picture.width) / picture.height;
  }

  return { width: scaledWidth, height: scaledHeight };
}



// WEBPACK FOOTER //
// ./src/routes/puzzles/components/PuzzleComponent/helpers/utils.js